export interface PersonalAccessTokenItem {
  key: string;
  name: string;
  database?: string;
  expirationDate?: Date;
  revokeDate?: Date;
  status?: {
    Value: number;
    DisplayValue: string;
  };
}

export class PersonalAccessToken extends Array<PersonalAccessTokenItem> {
  update(event: PersonalAccessToken): void {
    const currentItem = this.find((item) =>
      event.find((pat) => item.key === pat.key)
    );
    if (currentItem) {
      currentItem.status = event[0].status;
      currentItem.revokeDate = event[0].revokeDate;
    } else {
      this.push(event[0]);
    }
  }

  delete(key: string): void {
    const index = this.findIndex((item) => item.key === key);
    this.splice(index, 1);
  }
}
